module.exports = __webpack_public_path__ + "img/logo.0740f6c8.jpg";